import { render, staticRenderFns } from "./Estrutura.vue?vue&type=template&id=4009fbbc&"
import script from "./Estrutura.vue?vue&type=script&lang=js&"
export * from "./Estrutura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4009fbbc')) {
      api.createRecord('4009fbbc', component.options)
    } else {
      api.reload('4009fbbc', component.options)
    }
    module.hot.accept("./Estrutura.vue?vue&type=template&id=4009fbbc&", function () {
      api.rerender('4009fbbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Producao/Estrutura.vue"
export default component.exports